import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { genHttpParams } from 'src/app/_utils/utils';
import { environment } from 'src/environments/environment';
import { Observable, catchError, map, of } from 'rxjs';
import { BudgetDetails, BudgetDetailsBE } from 'src/interfaces/budget-details';
import { BudgetDetailsDialogComponent } from '../../presentation-sheet/budget-details-dialog/budget-details-dialog.component';
import { BudgetDetailsEditYearsDialogComponent } from '../../presentation-sheet/budget-details-edit-years-dialog/budget-details-edit-years-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class BudgetDetailsService {
  private readonly endpointQuery = `${environment.api}/scheda-presentazione-query/dettaglio-informazioni-bilancio`;
  private readonly endpointCommand = `${environment.api}/scheda-presentazione-command/dettaglio-informazioni-bilancio`;

  constructor(private http: HttpClient) {}

  getById(idScheda: string): Observable<BudgetDetails[]> {
    return this.http
      .get<BudgetDetailsBE[]>(this.endpointQuery + '/scheda/' + idScheda)
      .pipe(
        map((res) => {
          return (res || []).map((item) => {
            let current = parseFloat(item.current);
            let previus = parseFloat(item.previus);
            return {
              ...item,
              current: !isNaN(current) ? current : 0,
              previus: !isNaN(previus) ? previus : 0,
            };
          });
        }),
        catchError((err) => of(<BudgetDetails[]>[]))
      );
  }

  add(formData: Partial<BudgetDetails>, idScheda: string) {
    let body: Partial<BudgetDetails> = {
      ...formData,
      idScheda,
    };
    return this.http.post(this.endpointCommand, body);
  }

  edit(updateBudget: Partial<BudgetDetails>, id: string, idScheda: string) {
    let body: Partial<BudgetDetails> = {
      ...updateBudget,
      id,
      idScheda,
    };
    return this.http.put(this.endpointCommand + '/' + id, body);
  }

  editYears(
    years: { annoCorrente: string; annoPrecedente: string },
    idScheda: string
  ) {
    return this.http.put(this.endpointCommand + '/years/' + idScheda, years);
  }

  delete(id: string) {
    return this.http.delete(this.endpointCommand + '/' + id);
  }
}
